import type { Layout } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/components/RibbonControlGroupMLR';
import {
    sections,
    singleRow,
    stack,
} from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/components/RibbonControlGroupMLR/layoutTypings';
import { computedFn } from 'mobx-utils/lib/computedFn';
import type { ComposeViewState } from 'owa-mail-compose-store';
import type { RibbonGroupId } from 'owa-ribbon-ids';
import { getStringRibbonId, MailRibbonGroupId, MailRibbonControlId } from 'owa-ribbon-ids';

export const getMLRNotesTabGroupLayouts = computedFn(
    (group: RibbonGroupId, popoutComposeViewState?: ComposeViewState): Layout[] | undefined => {
        switch (group) {
            case MailRibbonGroupId.Group_Notes_Edit:
                return [
                    sections(
                        singleRow(getStringRibbonId(MailRibbonControlId.Notes_DeleteNote)),
                        singleRow(getStringRibbonId(MailRibbonControlId.Notes_ChangeColor))
                    ),
                    sections(
                        singleRow(
                            stack(
                                getStringRibbonId(MailRibbonControlId.Notes_DeleteNote),
                                getStringRibbonId(MailRibbonControlId.Notes_ChangeColor),
                                null
                            )
                        )
                    ),
                ];

            default:
                return undefined;
        }
    }
);
